module.exports = __webpack_public_path__ + "static/media/screenshot01.a166d654.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/screenshot01.png
// module id = 183
// module chunks = 0